import { render, staticRenderFns } from "./TechnologyLocationTechnicalControl.vue?vue&type=template&id=2a077ce0&"
import script from "./TechnologyLocationTechnicalControl.vue?vue&type=script&lang=js&"
export * from "./TechnologyLocationTechnicalControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports